module.exports = __webpack_public_path__ + "img/result-m.e94b2cfd.png";